import { render, staticRenderFns } from "./ShipmentCreateConfirmModal.vue?vue&type=template&id=b84d9000&scoped=true"
import script from "./ShipmentCreateConfirmModal.vue?vue&type=script&lang=js"
export * from "./ShipmentCreateConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./ShipmentCreateConfirmModal.vue?vue&type=style&index=0&id=b84d9000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d9000",
  null
  
)

export default component.exports